import { Link } from "react-router-dom";
import { BookOpen, Layers, Check, Target } from "lucide-react";

export function DailyGoal({ today }) {
  if (!today) return null;
  const items = [
    { done: today.lesson_done, label: "1 leçon", icon: BookOpen, id: "lesson", to: null },
    { done: today.review_done, label: "1 série de fiches", icon: Layers, id: "review", to: "/vocabulaire" },
  ];
  const count = items.filter((i) => i.done).length;
  const pct = (count / items.length) * 100;

  return (
    <section className="rise rise-1 bg-white rounded-2xl border-2 border-slate-200 p-4 space-y-3" data-testid="home-daily-goal">
      <div className="flex items-center justify-between">
        <span className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-slate-500">
          <Target className="w-4 h-4 text-orange-500" /> Objectif du jour
        </span>
        <span className="font-display text-xl font-bold" data-testid="home-daily-goal-count">{count}/{items.length}</span>
      </div>
      <div className="h-4 rounded-full bg-slate-100 overflow-hidden border border-slate-200">
        <div
          className={`h-full rounded-full transition-[width] duration-700 ${count === items.length ? "bg-emerald-500" : "hazard-stripe"}`}
          style={{ width: `${pct}%` }}
          data-testid="home-daily-goal-bar"
        />
      </div>
      <div className="grid grid-cols-2 gap-2">
        {items.map(({ done, label, icon: Icon, id, to }) => {
          const cls = `flex items-center gap-2 rounded-xl px-3 py-2 text-sm font-semibold border-2 ${
            done ? "bg-emerald-50 border-emerald-300 text-emerald-700" : "bg-slate-50 border-slate-200 text-slate-600"
          }`;
          const inner = (<>{done ? <Check className="w-4 h-4" /> : <Icon className="w-4 h-4" />} {label}</>);
          return to && !done ? (
            <Link key={id} to={to} className={`${cls} hover:border-orange-400 transition-colors`} data-testid={`home-goal-${id}`}>{inner}</Link>
          ) : (
            <div key={id} className={cls} data-testid={`home-goal-${id}`}>{inner}</div>
          );
        })}
      </div>
      {count === items.length && <p className="text-sm font-bold text-emerald-700" data-testid="home-daily-goal-done">Journée validée, bravo !</p>}
    </section>
  );
}
